import _ from 'lodash'
import React from 'react'
import { connect } from 'react-redux'
import {
  REDUCER,
  emailSignUpSuccess,
  togglePasswordVisibility,
  googleSignUpSuccess,
  googleSignUpFailure,
} from 'ducks/registration'
import Form from 'antd/lib/form'
import Icon from 'antd/lib/icon'
import Input from 'antd/lib/input'
import Button from 'antd/lib/button'
import Checkbox from 'antd/lib/checkbox'
import Alert from "antd/lib/alert";
import Link from 'components/CustomComponents/Localization/Link'

import { sprintf } from 'sprintf-js'
import axios from 'axios'
import qs from 'qs'
import l8n, { e } from 'l8n'
import linkit from 'scripts/linkit'

import { baseUrl } from 'scripts/env'
import { getGeoipCountry } from 'scripts/geoip';
import { AuthPolicy } from 'components/CleanComponents/AuthPolicy/index'
import GoogleSignIn from 'components/CustomComponents/SignIn/Google'
import PasswordToggle from 'components/CustomComponents/PasswordToggle'
import {googleSignInSuccess} from 'ducks/login'
import LocaleDropdown from "../../../Localization/LocaleDropdown";

const FormItem = Form.Item;
const mapStateToProps = (state) => ({
  formSubmitted: state.app.submitForms[REDUCER],
  passwordVisible: state.registration.passwordVisible,
  googleSignUpErrorMessage: state.registration.googleSignUpErrorMessage,
});

@connect(mapStateToProps)
@Form.create()
class EmailForm extends React.Component {
  /**
   * Ссылка на пользовательское соглашение для партнеров
   */
  agreementPdfLink = 'https://www.jivo.ru/files/partner_user_agreement.pdf';

  constructor(props) {
   super(props);
   // This should be used in constructor because Antd forms 'getFieldDecorator' method leads to component rerender
   this.debouncedCheckEmail = _.debounce(this.checkEmail.bind(this), 750);
  };  

  state = {
    country: null
  }
  
  componentDidMount() {
    getGeoipCountry().then(country => this.setState({country}));
  }

  onSubmit = (formSubmitted) => event => {
    event.preventDefault();
    const { form, dispatch } = this.props;
    if (! formSubmitted) {
      form.validateFields((error, values) => {
        if (!error) {
          dispatch(emailSignUpSuccess(values));
        }
      });
    }
  };

  togglePassword = event => {
    event.preventDefault();
    this.props.dispatch(togglePasswordVisibility());
  };

  checkEmail = (rule, value, callback) => {
    if (! value) {
      callback(e(l8n.p_required));
      return false;
    }

    axios
      .get(`${baseUrl}/user/email_check`, { params: { email: value }})
      .then(function (response) {
        if (!!response.data && response.data.available) {
          callback()
        } else {
          callback(e(l8n.p_email_not_available))
        }
      })
      .catch(function(error){
        callback(e(l8n.lblValidationError))
      })
  };

  onSuccessCallback = ({idToken, email, name}) => {
    const {dispatch} = this.props;
    this.checkEmail(null, email, function (err) {
      if (err) { //email уже есть в базе
        dispatch(googleSignInSuccess({idToken}));
      } else {
        dispatch(googleSignUpSuccess({idToken, name}));
      }
    });
  };

  onFailCallback = () => {
    this.props.dispatch(googleSignUpFailure(l8n.p_wrong_password));
  };

  getEmailFromQueryParams = () => {
    const queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true })

    return queryParams.email ? queryParams.email : null
  };

  render() {
    const { form, formSubmitted, passwordVisible, googleSignUpErrorMessage } = this.props;
    const onSuccessCallback = this.onSuccessCallback.bind(this);
    const onFailCallback = this.onFailCallback.bind(this);
    const togglePassword = this.togglePassword.bind(this);

    return (
      <React.Fragment>
        {!['RU', null].includes(this.state.country) ? (
          <React.Fragment>
            <GoogleSignIn
              onSuccessCallback={onSuccessCallback}
              onFailCallback={onFailCallback}
              buttonPrefix={l8n.sign_up_with}
            />
            {googleSignUpErrorMessage && <Alert
              message={googleSignUpErrorMessage}
              type="error"
            />}
            <div
              style={{ width: '100%', textAlign: 'center', margin: '20px 0 10px' }}
            >
              {l8n.or}
            </div>
          </React.Fragment>
        ) : null}
        <Form className="auth-form" hideRequiredMark onSubmit={this.onSubmit(formSubmitted)}>
          <FormItem hasFeedback>
            {form.getFieldDecorator('email', {
              initialValue: this.getEmailFromQueryParams(),
              validateFirst: true,
              rules: [
                { required: true, message: e(l8n.p_email_required) },
                { min: 6, message: e(sprintf(l8n.p_string_too_short, 6)) },
                { max: 100, message: e(sprintf(l8n.p_string_too_long, 100)) },
                { type: 'email', message: e(l8n.p_email_wrong) },
                { validator: this.debouncedCheckEmail },
              ],
            })(
              <Input
                prefix={<Icon type="user"  style={{ fontSize: '14px', color: 'rgba(0,0,0,.25)' }} />}
                placeholder={l8n.p_email}
                className="ant-input-lg"
                data-qa-id="registration-email-input"
              />,
            )}
          </FormItem>
          <FormItem className="password-input">
            {form.getFieldDecorator('password', {
              validateFirst: true,
              rules: [
                { required: true, message: e(l8n.p_password_required) },
                { min: 6, message: e(l8n.p_length6_required) },
                { max: 1024, message: e(sprintf(l8n.p_string_too_long, 1024)) },
                { pattern: /^.*[A-ZА-Я].*$/, message: e(l8n.p_uppercase_letter_required) },
                { pattern: /^.*\d+.*$/, message: e(l8n.p_digit_required) },
              ],
            })(
              <Input
                prefix={<Icon type="lock"  style={{ fontSize: '14px', color: 'rgba(0,0,0,.25)' }} />}
                type={! passwordVisible ? "password" : "text" }
                placeholder={l8n.p_password}
                suffix={<PasswordToggle visible={passwordVisible} onToggle={togglePassword}/>}
                className="ant-input-lg"
                data-qa-id="registration-password-input"
              />,
            )}
          </FormItem>
          {l8n.locale === 'ru' &&
            <FormItem>
              {form.getFieldDecorator('agreement', {
                valuePropName: 'checked',
                rules: [
                  {validator: (rule, value, callback) => {
                    if (!value) {
                      callback(l8n['error.agreement.required'])
                    } else {
                      callback();
                    }
                  }},
                ],
              })(
                <Checkbox data-qa-id="agreement-checkbox">
                  {linkit(l8n['agreement.checkbox_text'], [
                    {
                      className: 'utils__link--underlined',
                      href: this.agreementPdfLink,
                      target: '_blank',
                    }
                  ])}
                </Checkbox>
              )}
            </FormItem>
          }
          <div className="form-actions">
            <div style={{float: 'right', marginTop: 5}}>
              <LocaleDropdown/>
            </div>
            <Button type="primary" htmlType="submit" data-qa-id="registration-submit-button" loading={formSubmitted}>
              {l8n.p_request_submit}
            </Button>
            <span className="ml-3 register-link">
              <Link to="/login" className="text-primary utils__link--underlined" qaId="registration-login-link">
                {l8n.p_login}
              </Link>
            </span>
          </div>
          <AuthPolicy/>
        </Form>
      </React.Fragment>
    )
  }
}

export default EmailForm



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Form/RegistrationForm/EmailForm/index.js